import $ from 'jquery';
import fitvids from 'fitvids';

export default class RichText {
  constructor($el) {
    this.$el = $el;
    this.tabGroups = [];
    this.$tabGroups = this.$el.find('.tabs');

    this._initExternalLinks();
    this._switchTab = this._switchTab.bind(this);

    if (this.$tabGroups.length) {
      this.$tabGroups.each((i, el) => {
        this._initTabs(el);
      });
    }

    fitvids();
  }

  unload() {
    // Iterate backwards through the tab groups to remove event binding
    for (let i = this.tabGroups.length - 1; i >= 0; i--) {
      const events = this.tabGroups[i];
      events.forEach($el => $el.off('.tabs'));

      this.tabGroups.splice(i, 1);
    }
  }

  /**
   * Open links within an RTE field in a new window if they point to external domains
   *
   * @private
   */
  _initExternalLinks(){
    const anchors = this.$el.find('a[href^="http"]').filter((i, el) => {
      return el.href.indexOf(location.hostname) === -1;
    });

    anchors.attr('target', '_blank');
  }

  /**
   * Bind each grouping of tabs
   *  - If no active tab is defined, set the first tab as active
   *
   * @param el
   * @private
   */
  _initTabs(el) {
    const $tabsHeader = $(el);
    const $tabsContent = $tabsHeader.next('.tabs-content');

    if (!$tabsHeader.find('li.active').length) {
      $tabsHeader.find('li:first').addClass('active');
    }

    if (!$tabsContent.find('li.active').length) {
      $tabsContent.find('li:first').addClass('active');
    }

    const events = [
      $tabsHeader.on('click.tabs', 'li', this._switchTab),
      $tabsHeader.on('click.tabs', 'a', event => event.preventDefault()),
    ];

    this.tabGroups.push(events);
  }

  /**
   * Tab click handler
   *
   * @param event
   * @private
   */
  _switchTab(event) {
    const $target = $(event.currentTarget);
    const $tabsHeader = $target.parent('.tabs');
    const $tabsContent = $tabsHeader.next('.tabs-content');

    $target
      .addClass('active')
      .siblings()
      .removeClass('active');

    $tabsContent
      .find('> li')
      .eq($target.index())
      .addClass('active')
      .siblings()
      .removeClass('active');
  }
}
